import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import TRANSLATIONS_AR from "./locales/ar/translations.json";
import TRANSLATIONS_EN from "./locales/en/translations.json";
import { getItemOfSessionStorage } from "../../services/common/utils";
import { SELECTED_LANG } from "../../services/common/Constants";
// "Inline" English and Arabic translations.

// We can localize to any language and any number of languages.

const _lang = getItemOfSessionStorage(SELECTED_LANG);
//alert("lang from i18n:"+_lang);
//alert("i18next window.sessionStorage.getItem(key):"+window.sessionStorage.getItem("selectedLang"));
const resources = {
  en: {
    translation: TRANSLATIONS_EN,
  },

  ar: {
    translation: TRANSLATIONS_AR,
  },
};

i18next.use(initReactI18next).init({
  resources,
  lng: _lang === 'ar' ? 'ar' : 'en',
  fallbackLng: _lang,
  keySeparator: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18next; 
